import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['pagesTitle'] = {
  color: themeUi.semantic.color.text.neutral800
};

export default theme;
